import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return <DefaultErrorFallback error={this.state.error} onReset={() => this.setState({ hasError: false, error: null })} />;
    }
    return this.props.children;
  }
}

// Context-free fallback — hardcoded styles so it works even if ThemeContext or
// any other provider above it in the tree has crashed.
function DefaultErrorFallback({ error, onReset }) {
  const msg = error?.message || 'An unexpected error occurred.';
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0f172a', color: '#f1f5f9', fontFamily: 'system-ui, sans-serif', padding: '24px',
    }}>
      <div style={{
        background: '#1e293b', borderRadius: '16px', padding: '32px', maxWidth: '360px',
        width: '100%', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,.4)',
      }}>
        <div style={{
          width: '56px', height: '56px', borderRadius: '50%', background: '#fecaca',
          display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px',
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
            <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>Something went wrong</h2>
        <p style={{ color: '#94a3b8', fontSize: '14px', marginBottom: '24px', wordBreak: 'break-word' }}>{msg}</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: 'linear-gradient(135deg,#f97316,#ec4899)', color: '#fff',
              border: 'none', borderRadius: '10px', padding: '12px', fontSize: '14px',
              fontWeight: '600', cursor: 'pointer',
            }}
          >
            Reload App
          </button>
          {onReset && (
            <button
              onClick={onReset}
              style={{
                background: 'transparent', color: '#94a3b8', border: '1px solid #334155',
                borderRadius: '10px', padding: '10px', fontSize: '14px', cursor: 'pointer',
              }}
            >
              Try Again
            </button>
          )}
          <button
            onClick={() => { window.location.href = '/'; }}
            style={{
              background: 'transparent', color: '#64748b', border: 'none',
              padding: '8px', fontSize: '13px', cursor: 'pointer',
            }}
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorBoundary;
